import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=12f200c5&"
import script from "./back-button.vue.ts?vue&type=script&lang=ts&"
export * from "./back-button.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports